import { render, staticRenderFns } from "./cOrders.vue?vue&type=template&id=6a008d0a&scoped=true"
import script from "./cOrders.vue?vue&type=script&lang=js"
export * from "./cOrders.vue?vue&type=script&lang=js"
import style0 from "./cOrders.vue?vue&type=style&index=0&id=6a008d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a008d0a",
  null
  
)

export default component.exports